import { render, staticRenderFns } from "./SdOverlays.vue?vue&type=template&id=59b9f272&scoped=true"
import script from "./SdOverlays.vue?vue&type=script&lang=js"
export * from "./SdOverlays.vue?vue&type=script&lang=js"
import style0 from "./SdOverlays.vue?vue&type=style&index=0&id=59b9f272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b9f272",
  null
  
)

export default component.exports